import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { EnterpriseAuthProvider, useEnterpriseAuth } from './context/EnterpriseAuthContext';
import { Toaster } from './components/ui/sonner';
import EnterpriseLogin from './pages/EnterpriseLogin';
import ProductionDashboard from './pages/ProductionDashboard';
import DashboardLayout from './pages/DashboardLayout';
import CreateProfile from './pages/CreateProfile';
import ProfileDetail from './pages/ProfileDetail';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useEnterpriseAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <EnterpriseAuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<EnterpriseLogin />} />
          <Route
            path="/production"
            element={
              <PrivateRoute>
                <ProductionDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<ProductionDashboard />} />
            <Route path="create" element={<CreateProfile />} />
            <Route path="profile/:id" element={<ProfileDetail />} />
          </Route>
          <Route path="/" element={<Navigate to="/production" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </EnterpriseAuthProvider>
  );
}

export default App;
